import { useState } from "react";
import DotLoader from "react-spinners/DotLoader";

const override = {
    display: "flex",
    margin: "0 auto",
    padding: "5px"
};

export function Spinner({ isSpinner, colorSpinner, textSpinner, sizeSpinner }) {

    const [loading] = useState(isSpinner);
    const [color] = useState(colorSpinner);
    const [text] = useState(textSpinner);
    const [size] = useState(sizeSpinner);

    return (
        <>
            <div className="sweet-loading">
                <DotLoader color={color} loading={loading} cssOverride={override} size={size ?? 150} />
                <p className="mt-5 pt-5">
                {text}
            </p>

            </div>   
        </>

    );

}

